import React, { useState, useRef, useCallback, useEffect } from 'react';

const useUserActivity = (idleTimeout = 5 * 60 * 1000) => {
  const [isActive, setIsActive] = useState(true);
  const lastActivityRef = useRef(Date.now());

  const handleActivity = useCallback(() => {
    lastActivityRef.current = Date.now();
  }, []);

  // Set up event listeners only once on mount
  useEffect(() => {
    const events = ['mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });
    
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [handleActivity]);

  // Check activity status
  useEffect(() => {
    // Calculate an appropriate check interval directly
    const calculatedInterval = Math.floor(idleTimeout / 5);
    const checkInterval = Math.max(1000, Math.min(calculatedInterval, 30000));
    
    const checkActivity = () => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivityRef.current;
      
      if (timeSinceLastActivity >= idleTimeout) {
        setIsActive(false);
      } else if (timeSinceLastActivity < idleTimeout) {
        setIsActive(true);
      }
    };

    const intervalId = setInterval(checkActivity, checkInterval);
    return () => clearInterval(intervalId);
  }, [idleTimeout]);

  return isActive;
};

export default useUserActivity;
